<!-- @format -->

<template>
  <DefaultLayout>
    <div class="mobile--menu">
      <div class="w-layout-hflex header--wrapper">
        <a href="#home" aria-current="page" class="brand w-inline-block w--current">
          <div class="sign--wrapper">
            <div class="toggle--wrapper">
              <img
                src="@/assets/img/swipez--toggle--shape.svg"
                loading="lazy"
                alt=""
                class="sign--toggle"
              />
            </div>
            <img
              src="@/assets/img/swipez--sqaure--shape.svg"
              loading="lazy"
              alt=""
              class="sign--square"
            />
          </div>
          <div class="w-layout-hflex swipez--text--wrapper">
            <img
              src="@/assets/img/Swipez--text--logo.svg"
              loading="lazy"
              alt="Swipez logotype"
              class="swipez--text--logo"
            />
          </div>
        </a>
        <a
          aria-label="Close menu button"
          data-w-id="8976391a-d210-976d-86a3-3787b3af7718"
          href="#"
          class="menu--button w-inline-block"
        >
          <div class="hamb--line is--close-1"></div>
          <div class="hamb--line is--close--2"></div>
        </a>
      </div>
      <div class="nav is--mobile--menu">
        <a
          data-w-id="8976391a-d210-976d-86a3-3787b3af7702"
          href="#account"
          class="nav--link w-inline-block"
        >
          <div>{{ $t("Account") }}</div>
        </a>
        <a
          data-w-id="8976391a-d210-976d-86a3-3787b3af7705"
          href="#features"
          class="nav--link w-inline-block"
        >
          <div>{{ $t("Features") }}</div>
        </a>
        <a
          data-w-id="8976391a-d210-976d-86a3-3787b3af7708"
          href="#pricing"
          class="nav--link w-inline-block"
        >
          <div>{{ $t("Pricing") }}</div>
        </a>
        <a
          data-w-id="8976391a-d210-976d-86a3-3787b3af770b"
          href="#faq"
          class="nav--link w-inline-block"
        >
          <div>{{ $t("FAQ") }}</div>
        </a>
        <a
          data-w-id="8976391a-d210-976d-86a3-3787b3af770e"
          href="#contact"
          class="nav--link w-inline-block"
        >
          <div>{{ $t("Contact") }}</div>
        </a>
        <LocaleSwitcher />
      </div>
      <div class="cta--wrapper is--mobile--menu">
        <a
          :href="adminUrl + 'login' + '?lng=' + locale"
          class="button is-secondary is--mobile--menu w-inline-block"
        >
          <div>{{ $t("Log in") }}</div>
        </a>
        <a
          :href="adminUrl + 'signup' + '?lng=' + locale"
          class="button is--mobile--menu w-inline-block"
        >
          <div>{{ $t("header.Sign Up") }}</div>
        </a>
      </div>
    </div>
    <div class="w-layout-hflex header is--dark">
      <div class="w-layout-hflex header--wrapper">
        <a href="#home" aria-current="page" class="brand w-inline-block w--current">
          <div class="sign--wrapper">
            <div class="toggle--wrapper">
              <img
                src="@/assets/img/swipez--toggle--shape.svg"
                loading="lazy"
                alt=""
                class="sign--toggle"
              />
            </div>
            <img
              src="@/assets/img/swipez--sqaure--shape.svg"
              loading="lazy"
              alt=""
              class="sign--square"
            />
          </div>
          <div class="w-layout-hflex swipez--text--wrapper">
            <img
              src="@/assets/img/Swipez--text--logo.svg"
              loading="lazy"
              alt="Swipez logotype"
              class="swipez--text--logo"
            />
          </div>
        </a>
        <div class="nav">
          <a href="#account" class="nav--link w-inline-block">
            <div>{{ $t("Account") }}</div>
          </a>
          <a href="#features" class="nav--link w-inline-block">
            <div>{{ $t("Features") }}</div>
          </a>
          <a href="#pricing" class="nav--link w-inline-block">
            <div>{{ $t("Pricing") }}</div>
          </a>
          <a href="#faq" class="nav--link w-inline-block">
            <div>{{ $t("FAQ") }}</div>
          </a>
          <a href="#contact" class="nav--link w-inline-block">
            <div>{{ $t("Contact") }}</div>
          </a>
          <LocaleSwitcher />
        </div>
        <div class="cta--wrapper">
          <a
            :href="adminUrl + 'login' + '?lng=' + locale"
            class="button is-secondary w-inline-block"
          >
            <div>{{ $t("Log in") }}</div>
          </a>
          <a :href="adminUrl + 'signup' + '?lng=' + locale" class="button w-inline-block">
            <div>{{ $t("header.Sign Up") }}</div>
          </a>
        </div>
        <a
          aria-label="Menu button"
          data-w-id="a8c6efb2-b7f6-afdb-7057-876b412a11f0"
          href="#"
          class="menu--button w-inline-block"
        >
          <div class="hamb--line"></div>
          <div class="hamb--line"></div>
        </a>
      </div>
      <div class="header--overlay"></div>
    </div>
    <div data-w-id="72fa98d1-19f4-83d1-4385-6e838d8fa27b" class="hero" id="home">
      <div data-w-id="a0d3df64-731a-5edf-5c16-4707d32675b2" class="hero--main--overlay"></div>
      <div class="hero--title--wrapper">
        <h1 class="h">
          <div class="hero-h-wrapper">
            <div class="h--super-large" v-html="$t('UNITED BANKING')"></div>
          </div>
        </h1>
        <p
          class="p--large"
          v-html="
            $t('Connect your partners into unified ecosystem for rapid and secure fund flows')
          "
        ></p>
      </div>
      <div class="w-layout-hflex more--wrapper">
        <a aria-label="Read more button" href="#account" class="more w-inline-block">
          <img src="@/assets/img/arrow--more.svg" loading="lazy" alt="" class="more--icon" />
        </a>
      </div>
      <div class="hero--img--wrapper">
        <div class="gradient--bottom"></div>
        <div class="gradient--top"></div>
        <div class="hero--img-overlay"></div>
        <div
          data-w-id="4fef72d0-1401-f900-0d7b-69a1c139b116"
          style="opacity: 0; display: none"
          class="hero--img"
          data-animation-type="spline"
          data-spline-url="https://prod.spline.design/IYaDkgY9wzTQCd-a/scene.splinecode"
        >
          <canvas></canvas>
        </div>
      </div>
    </div>
    <div class="account">
      <div id="account" class="anchor"></div>
      <div class="w-layout-hflex global--padding">
        <div class="global--wrapper">
          <div class="block--h">
            <div class="h-line">
              <div class="inner--line--black"></div>
            </div>
            <div class="text--chip">{{ $t("Account") }}</div>
            <div class="h-line">
              <div class="inner--line--black"></div>
            </div>
          </div>
          <div class="hero--title--wrapper">
            <h2 class="h--large black" v-html="$t('account.PERSONAL AND BUSINESS ACCOUNT')"></h2>
            <p
              class="p--large is--black"
              v-html="$t('account.Manage all your financial transactions')"
            ></p>
            <a :href="adminUrl + 'signup'" class="button is--black w-inline-block">
              <div>{{ $t("account.Create Account") }}</div>
            </a>
          </div>
          <div class="columns--wrapper">
            <div class="w-layout-hflex row--wrapper">
              <div class="service--item">
                <img src="@/assets/img/fast--icon.svg" loading="lazy" alt="" />
                <div class="w-layout-vflex flex-block-6">
                  <h2 class="h--large is--black">{{ $t("account.Fast") }}</h2>
                  <h3 class="h--medium black">
                    {{ $t("account.Fast online application and onboarding") }}
                  </h3>
                </div>
              </div>
              <div class="v-line">
                <div class="inner--line--black-v"></div>
              </div>
              <div class="service--item">
                <img src="@/assets/img/light--icon.svg" loading="lazy" alt="" />
                <div class="w-layout-vflex flex-block-6">
                  <h2 class="h--large is--black">{{ $t("account.Simple") }}</h2>
                  <h3 class="h--medium black">
                    {{ $t("account.Execute all banking tasks at lightspeed") }}
                  </h3>
                </div>
              </div>
            </div>
            <div class="h-line">
              <div class="inner--line--black"></div>
            </div>
            <div class="w-layout-hflex row--wrapper">
              <div class="service--item">
                <img src="@/assets/img/planet--icon.svg" loading="lazy" alt="" />
                <div class="w-layout-vflex flex-block-6">
                  <h2 class="h--large is--black">{{ $t("account.Global") }}</h2>
                  <h3 class="h--medium black">
                    {{ $t("account.SEPA & SWIFT for easy fund transfers globally") }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="features">
      <div id="features" class="anchor"></div>
      <div class="w-layout-hflex global--padding">
        <div class="global--wrapper wide">
          <div class="block--h">
            <div class="h-line is--white">
              <div class="inner--line--right"></div>
            </div>
            <div class="text--chip is--yellow">{{ $t("Features") }}</div>
            <div class="h-line is--white">
              <div class="inner--line--right"></div>
            </div>
          </div>
          <h2 class="h--large is--white is--center" v-html="$t('features.UNITY AT THE CORE')"></h2>
          <div class="v-sep">
            <div class="inner--line--white"></div>
            <div class="w-layout-hflex flex-block-3">
              <div class="inner--line--white"></div>
            </div>
          </div>
          <div class="feature--item">
            <div class="w-layout-hflex flex-block-2">
              <div class="div-block-3">
                <div class="text-block">01</div>
              </div>
              <h2 class="h--large is--white">{{ $t("account.TOP-TIER SECURITY") }}</h2>
            </div>
            <p class="p--medium is--feature-p">{{ $t("account.Trust") }}</p>
          </div>
          <div class="v-sep">
            <div class="inner--line--white"></div>
            <div class="w-layout-hflex flex-block-3">
              <div class="inner--line--white"></div>
            </div>
          </div>
          <div class="feature--item">
            <div class="w-layout-hflex flex-block-2">
              <div class="div-block-3">
                <div class="text-block">02</div>
              </div>
              <h2 class="h--large is--white" v-html="$t('account.SMOOTH TRANSACTIONS')"></h2>
            </div>
            <p class="p--medium is--feature-p">{{ $t("account.Experience") }}</p>
          </div>
          <div class="v-sep">
            <div class="inner--line--white"></div>
            <div class="w-layout-hflex flex-block-3">
              <div class="inner--line--white"></div>
            </div>
          </div>
          <div class="feature--item">
            <div class="w-layout-hflex flex-block-2">
              <div class="div-block-3">
                <div class="text-block">03</div>
              </div>
              <h2 class="h--large is--white">{{ $t("account.INTEGRATED ECOSYSTEM") }}</h2>
            </div>
            <p class="p--medium is--feature-p">{{ $t("account.Our platform") }}</p>
          </div>
          <div class="feature--item--block">
            <div class="div-block-3">
              <div class="text-block">{{ $t("EXPLORE") }}</div>
            </div>
            <h2 class="h--large is--white v--2">
              {{ $t("EXPLORE A COMPLETE FINANCIAL PLATFORM POWERED BY BANK ACCOUNT") }}
            </h2>
            <a :href="adminUrl + 'signup'" class="button w-inline-block">
              <div>{{ $t("account.Create Account") }}</div>
            </a>
            <div class="div-block-4"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="pricing">
      <div id="pricing" class="anchor"></div>
      <div class="w-layout-hflex global--padding">
        <div class="global--wrapper">
          <div class="block--h">
            <div class="h-line">
              <div class="inner--line--black"></div>
            </div>
            <div class="text--chip">{{ $t("pricing.PRICING") }}</div>
            <div class="h-line">
              <div class="inner--line--black"></div>
            </div>
          </div>
          <div class="pricing--wrapper">
            <h2 class="h--large black">{{ $t("pricing.EXPLORE OUR PRICING") }}</h2>
            <a href="#contact" class="button is--black w-inline-block">
              <div>{{ $t("pricing.Contact Sales") }}</div>
            </a>
          </div>
          <div class="tabs w-tabs">
            <div class="tabs-menu w-tab-menu">
              <a data-w-tab="Business" class="tab w-inline-block w-tab-link w--current">
                <div>{{ $t("pricing.BUSINESS") }}</div>
              </a>
              <a data-w-tab="Private Individuals" class="tab w-inline-block w-tab-link">
                <div>{{ $t("pricing.PRIVATE INDIVIDUALS") }}</div>
              </a>
              <a data-w-tab="Personal" class="tab w-inline-block w-tab-link">
                <div>{{ $t("pricing.PERSONAL") }}</div>
              </a>
            </div>
            <div class="tabs-content w-tab-content">
              <div data-w-tab="Business" class="tab-pane-personal w-tab-pane w--tab-active">
                <div class="pricing--table--wrapper">
                  <div class="w-layout-hflex price--item">
                    <div>
                      {{ $t("pricing.ON REQUEST") }}
                    </div>
                    <!-- <div>2000 EUR</div> -->
                  </div>
                  <!-- <div class="w-layout-hflex price--item">
                    <div>{{ $t("pricing.Account monthly service fee") }}</div>
                    <div>100 EUR</div>
                  </div>
                  <div class="w-layout-hflex price--item">
                    <div>{{ $t("pricing.Incoming internal payment") }}</div>
                    <div>{{ $t("pricing.Free of change") }}</div>
                  </div>
                  <div class="w-layout-hflex price--item">
                    <div>{{ $t("pricing.Incoming SEPA-payment") }}</div>
                    <div>0.5%</div>
                  </div>
                  <div class="w-layout-hflex price--item">
                    <div>{{ $t("pricing.Incoming SWIFT-payment") }}</div>
                    <div>0.7%</div>
                  </div>
                  <div class="w-layout-hflex price--item">
                    <div>
                      {{
                        $t("pricing.Internal outgoing payment between own accounts with in Swipez")
                      }}
                    </div>
                    <div>{{ $t("pricing.Free of change") }}</div>
                  </div>
                  <div class="w-layout-hflex price--item">
                    <div>{{ $t("pricing.Internal outgoing payment with in Swipez") }}</div>
                    <div>{{ $t("pricing.Free of change") }}</div>
                  </div>
                  <div class="w-layout-hflex price--item">
                    <div>{{ $t("pricing.Outgoing SEPA-payment") }}</div>
                    <div>0.1%</div>
                  </div>
                  <div class="w-layout-hflex price--item">
                    <div>{{ $t("pricing.Outgoing SWIFT-payment") }}</div>
                    <div>0.3%</div>
                  </div> -->
                </div>
              </div>
              <div data-w-tab="Private Individuals" class="w-tab-pane">
                <div class="pricing--table--wrapper">
                  <div class="w-layout-hflex price--item">
                    <div>
                      {{ $t("pricing.Handling of documents and opening a customer account") }}
                    </div>
                    <div>1000 EUR</div>
                  </div>
                  <div class="w-layout-hflex price--item">
                    <div>{{ $t("pricing.Account monthly service fee") }}</div>
                    <div>75 EUR</div>
                  </div>
                  <div class="w-layout-hflex price--item">
                    <div>{{ $t("pricing.Incoming internal payment") }}</div>
                    <div>{{ $t("pricing.Free of change") }}</div>
                  </div>
                  <div class="w-layout-hflex price--item">
                    <div>{{ $t("pricing.Incoming SEPA-payment") }}</div>
                    <div>0.5%</div>
                  </div>
                  <div class="w-layout-hflex price--item">
                    <div>{{ $t("pricing.Incoming SWIFT-payment") }}</div>
                    <div>0.7%</div>
                  </div>
                  <div class="w-layout-hflex price--item">
                    <div>
                      {{
                        $t("pricing.Internal outgoing payment between own accounts with in Swipez")
                      }}
                    </div>
                    <div>{{ $t("pricing.Free of change") }}</div>
                  </div>
                  <div class="w-layout-hflex price--item">
                    <div>{{ $t("pricing.Internal outgoing payment with in Swipez") }}</div>
                    <div>{{ $t("pricing.Free of change") }}</div>
                  </div>
                  <div class="w-layout-hflex price--item">
                    <div>{{ $t("pricing.Outgoing SEPA-payment") }}</div>
                    <div>0.1%</div>
                  </div>
                  <div class="w-layout-hflex price--item">
                    <div>{{ $t("pricing.Outgoing SWIFT-payment") }}</div>
                    <div>0.3%</div>
                  </div>
                </div>
              </div>
              <div data-w-tab="Personal" class="w-tab-pane">
                <div class="pricing--table--wrapper">
                  <div class="w-layout-hflex price--item">
                    <div>{{ $t("pricing.Opening a customer account") }}</div>
                    <div>{{ $t("pricing.Free of change") }}</div>
                  </div>
                  <div class="w-layout-hflex price--item">
                    <div>{{ $t("pricing.Account monthly service fee") }}</div>
                    <div>{{ $t("pricing.Free of change") }}</div>
                  </div>
                  <div class="w-layout-hflex price--item">
                    <div>{{ $t("pricing.Incoming internal payment") }}</div>
                    <div>{{ $t("pricing.Free of change") }}</div>
                  </div>
                  <div class="w-layout-hflex price--item">
                    <div>{{ $t("pricing.Incoming SEPA-payment") }}</div>
                    <div>{{ $t("pricing.Free of change") }}</div>
                  </div>
                  <div class="w-layout-hflex price--item">
                    <div>{{ $t("pricing.Incoming SWIFT-payment") }}</div>
                    <div>10 USD</div>
                  </div>
                  <div class="w-layout-hflex price--item">
                    <div>{{ $t("pricing.Payment card top-up") }}</div>
                    <div>1.5%</div>
                  </div>
                  <div class="w-layout-hflex price--item">
                    <div>{{ $t("pricing.Internal outgoing payment") }}</div>
                    <div>{{ $t("pricing.Free of change") }}</div>
                  </div>
                  <div class="w-layout-hflex price--item">
                    <div>{{ $t("pricing.Outgoing SEPA-payment") }}</div>
                    <div>5 EUR</div>
                  </div>
                  <div class="w-layout-hflex price--item">
                    <div>{{ $t("pricing.Outgoing SWIFT-payment") }}</div>
                    <div>20 USD</div>
                  </div>
                  <div class="w-layout-hflex price--item">
                    <div>{{ $t("pricing.Withdrawal to card") }}</div>
                    <div>1.5%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="faq">
      <div id="faq" class="anchor"></div>
      <div class="w-layout-hflex global--padding">
        <div class="global--wrapper">
          <div class="block--h">
            <div class="h-line is--white">
              <div class="inner--line--right"></div>
            </div>
            <div class="text--chip is--yellow">{{ $t("questtions.FAQ") }}</div>
            <div class="h-line is--white">
              <div class="inner--line--right"></div>
            </div>
          </div>
          <h2
            class="h--large is--white is--center"
            v-html="$t('questtions.FREQUENTLY ASKED QUESTIONS')"
          ></h2>
          <div class="faq--wrapper">
            <div class="v-sep">
              <div class="inner--line--white"></div>
            </div>
            <div class="faq--item">
              <div
                data-w-id="760e5155-fb16-35d5-58ca-9cd55997e12d"
                class="w-layout-hflex ac--header"
              >
                <div>{{ $t("questtions.What country is Swipez registered at?") }}</div>
                <div class="open--acc--button">
                  <div class="ac--line--2"></div>
                  <div class="ac--line--1"></div>
                </div>
              </div>
              <div
                style="width: 100%; height: 0px; display: none"
                class="w-layout-hflex ac--content"
              >
                <div class="w-layout-hflex flex-block-4">
                  <div class="p--medium">
                    {{ $t("questtions.Swipez company is registered in the Czech Republic") }}
                  </div>
                </div>
              </div>
            </div>
            <div class="v-sep">
              <div class="inner--line--white"></div>
            </div>
            <div class="faq--item">
              <div
                data-w-id="419f7d68-2ad8-a547-6c62-027e884bd110"
                class="w-layout-hflex ac--header"
              >
                <div>{{ $t("questtions.How safe is Swipez service?") }}</div>
                <div class="open--acc--button">
                  <div class="ac--line--2"></div>
                  <div class="ac--line--1"></div>
                </div>
              </div>
              <div
                style="width: 100%; height: 0px; display: none"
                class="w-layout-hflex ac--content"
              >
                <div class="w-layout-hflex flex-block-4">
                  <div class="p--medium">
                    {{
                      $t(
                        "questtions.We use technologies that guarantee secure online payments and two-factor authentication"
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="v-sep">
              <div class="inner--line--white"></div>
            </div>
            <div class="faq--item">
              <div
                data-w-id="74d9ef66-4bfe-eb9d-5c86-5c593910a767"
                class="w-layout-hflex ac--header"
              >
                <div>{{ $t("questtions.How safe is it to keep money at Swipez?") }}</div>
                <div class="open--acc--button">
                  <div class="ac--line--2"></div>
                  <div class="ac--line--1"></div>
                </div>
              </div>
              <div
                style="width: 100%; height: 0px; display: none"
                class="w-layout-hflex ac--content"
              >
                <div class="w-layout-hflex flex-block-4">
                  <div class="p--medium">
                    {{
                      $t(
                        "questtions.Funds of our customers are kept in a separate account in the Czech bank"
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="v-sep">
              <div class="inner--line--white"></div>
            </div>
            <div class="faq--item">
              <div
                data-w-id="b6314e4c-3ffa-56ed-4396-96b5460f593a"
                class="w-layout-hflex ac--header"
              >
                <div>
                  {{ $t("questtions.What documents must be presented for opening an account?") }}
                </div>
                <div class="open--acc--button">
                  <div class="ac--line--2"></div>
                  <div class="ac--line--1"></div>
                </div>
              </div>
              <div
                style="width: 100%; height: 0px; display: none"
                class="w-layout-hflex ac--content"
              >
                <div class="w-layout-hflex flex-block-4">
                  <div class="p--medium">
                    {{
                      $t("questtions.When opening an account, a passport or ID card is required")
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="v-sep">
              <div class="inner--line--white"></div>
            </div>
            <div class="faq--item">
              <div
                data-w-id="181dfd99-99df-ecc6-8367-0416fe0b12cd"
                class="w-layout-hflex ac--header"
              >
                <div>{{ $t("questtions.When will I get access to the online bank?") }}</div>
                <div class="open--acc--button">
                  <div class="ac--line--2"></div>
                  <div class="ac--line--1"></div>
                </div>
              </div>
              <div
                style="width: 100%; height: 0px; display: none"
                class="w-layout-hflex ac--content"
              >
                <div class="w-layout-hflex flex-block-4">
                  <div class="p--medium">
                    {{
                      $t(
                        "questtions.You will get access as soon as your identity is checked and verified"
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="v-sep">
              <div class="inner--line--white"></div>
            </div>
            <div class="faq--item">
              <div
                data-w-id="9407adf3-6b2d-8a5d-d546-f805cb02f035"
                class="w-layout-hflex ac--header"
              >
                <div>
                  {{ $t("questtions.Residents of what countries may not open an account?") }}
                </div>
                <div class="open--acc--button">
                  <div class="ac--line--2"></div>
                  <div class="ac--line--1"></div>
                </div>
              </div>
              <div
                style="width: 100%; height: 0px; display: none"
                class="w-layout-hflex ac--content"
              >
                <div class="w-layout-hflex flex-block-4">
                  <div class="p--medium">
                    {{ $t("questtions.Currently, an account may be opened") }}
                  </div>
                </div>
              </div>
            </div>
            <div class="v-sep">
              <div class="inner--line--white"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </DefaultLayout>
</template>

<script setup lang="ts">
// Импорты из Vue 3 Composition API

import { DefaultLayout } from "@/layout";
import { ref, computed, defineProps, defineEmits, onMounted, watch } from "vue";
import HomeAdapterService from "./adapter/HomeAdapterService";
import Footer from "@/layout/Footer.vue";
import LocaleSwitcher from "@/locales/LocaleSwitcher.vue";
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
let adminUrl = ref("");
const curLang = ref("cz");
onMounted(async () => {
  curLang.value = localStorage.getItem("locale") || "cz";
  loadSettings();
  // const script = document.createElement("script");
  // script.src = "/webflow.js";
  // script.defer = true;
  // script.onload = () => {
  //   setTimeout(() => {
  //     if (typeof Webflow !== "undefined") {
  //       Webflow.ready();
  //       Webflow.require("ix2").init(); // Запуск анимаций
  //       console.log("✅ Webflow анимации инициализированы!");
  //     } else {
  //       console.error("❌ Webflow не найден!");
  //     }
  //   }, 1000); // Задержка 500 мс
  // };
  // document.body.appendChild(script);
});
async function loadSettings() {
  try {
    // Запрашиваем файл appWebSettings.json из папки public
    const response = await fetch("/appWebSettings.json");

    // Проверяем, что запрос успешен
    if (!response.ok) {
      throw new Error("Не удалось загрузить настройки");
    }

    // Преобразуем ответ в JSON
    const settings = await response.json();

    // Сохраняем нужные параметры в переменные
    adminUrl.value = settings.adminUrl;
  } catch (error) {
    console.error("Ошибка при загрузке настроек:", error);
  }
}
</script>

<style lang="scss">
.header {
  background-image: linear-gradient(rgba(0, 0, 0, 0.88) 50%, rgba(0, 0, 0, 0.24));
}
.black {
  color: #000 !important;
}
</style>
